import { baseConfig } from './base.config';
import { getCurrentConfig } from '@i18n-ecom-seller/build-runtime/regionConfig';

export const REGION_CONFIG = getCurrentConfig(
  // @ts-ignore: require.context is an API injected by the build tool
  require.context('./', true, /(fans|tts)\/(\w+?).tsx?/),
  baseConfig
);
